<template>
  <span>
    <help-no-device v-if="!progress && gateways.length == 0"></help-no-device>
    <v-container v-else grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex v-for="(gw, idx) in gateways" :key="idx" xs12 sm6 lg4>
          <v-card
            :dark="gw.status=='online'"
            class="elevation-10 ma-3"
            :color="gw.id == 'LOCAL' ? 'teal' : ''"
          >
            <v-container fill-height>
              <v-layout row wrap justify-center>
                <v-tooltip v-if="gw.help" left max-width="300">
                  <template v-slot:activator="{ on }">
                    <v-btn large icon absolute right v-on="on">
                      <v-icon large color="white">info</v-icon>
                    </v-btn>
                  </template>
                  {{$t(gw.help)}}
                </v-tooltip>
                <!-- <v-tooltip v-if="gw.status!='online'" left max-width="300">
                  <template v-slot:activator="{ on }">
                    <v-btn color="grey" large icon absolute left v-on="on" target="_blank" :href="`http://gw-${gw.id}.local`">
                      <v-icon color="white">open_in_new</v-icon>
                    </v-btn>
                  </template>
                  {{$t('info-on-device-offline-try-local')}}
                </v-tooltip> -->
                <v-flex xs5>
                  <v-container fill-height>
                    <v-layout align-content-center fill-height justify-center>
                      <v-img
                        v-if="gw.status=='online'"
                        src="./img/gateway.png"
                        height="150"
                        contain
                      ></v-img>
                      <v-tooltip v-else-if="gw.status=='offline'" bottom>
                        <template v-slot:activator="{ on }">
                          <v-img height="150" v-on="on">
                            <v-icon size="100">report</v-icon>
                          </v-img>
                        </template>
                        <span>{{$t('info-on-device-offline')}}</span>
                      </v-tooltip>
                      <v-img v-else height="150">
                        <v-progress-circular size="100" indeterminate></v-progress-circular>
                      </v-img>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs7>
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">{{gw.id}}</div>
                      <div>{{gw.card}}</div>
                      <div>{{gw.local}}</div>
                    </div>
                  </v-card-title>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="gw.status!='online'"
                    flat
                    :dark="gw.status=='online'"
                    @click="blinkAgent(gw)"
                    v-on="on"
                  >{{$t('identify')}}</v-btn>
                </template>
                <span>{{$t('identify-tooltip')}}</span>
              </v-tooltip>

              <v-spacer />
                <v-tooltip v-if="gw.status!='online'" left max-width="300">
                  <template v-slot:activator="{ on }">
                    <v-btn color="grey" v-on="on" target="_blank" :href="`http://${gw.local}`">
                      {{$t('connect')}}<v-icon>open_in_new</v-icon>
                    </v-btn>
                  </template>
                  {{$t('info-on-device-offline-try-local')}}
                </v-tooltip>

              <v-btn
                :disabled="gw.status!='online'"
                flat
                :dark="gw.status=='online'"
                @click="setAgent(gw)"
              >{{$t('connect')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <search-status></search-status>
  </span>
</template>


<script>
import { mapState } from "vuex";
import SearchStatus from "./SearchStatus";
import HelpNoDevice from "./HelpNoDevice";
export default {
  components: {
    SearchStatus,
    HelpNoDevice
  },

  created() {
    this.scan();
  },
  beforeDestroy() {
    if (this.timeout) {
      console.log("Clear timeout");
      clearTimeout(this.timeout);
    }
  },
  computed: {
    ...mapState({
      gateways: state => state.gateways.full
    }),
    progress() {
      return this.loading || this.full.some(gw => gw.status === "testing");
    },
    ...mapState("gateways", ["loading", "full"])
  },
  methods: {
    scan() {
      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.$store
        .dispatch("gateways/scan")
        .then(() => {
          this.$store
            .dispatch("gateways/scanV2")

          if (this.continueScan) {
            console.log("Scheduling a new scan in 30 seconds...");
            this.timeout = setTimeout(this.scan, 30000);
          }
        })
        .catch(() => {});
    },
    setAgent(gw) {
      this.$store.dispatch("gateways/setCurrent", gw).then(() => {
        this.$router.push({ name: "login" });
      });
    },
    blinkAgent(gw) {
      this.$store.dispatch("gateways/blink", gw).then(() => {
        console.log("Blinked ", gw);
      });
    }
  },

  data() {
    return {
      continueScan: false,
      timeout: null
    };
  }
};
</script>

<style>
v-card {
  margin: 30px;
}
</style>
